/* eslint-disable import/prefer-default-export,react/forbid-prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isIOS } from 'react-device-detect';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import Input from '../../../../components/Input';
import { OnboardingBodyLayout } from '../partials';

export const ConfirmEmailComponent = ({
  form,
  handleSubmit,
  handleSendEmail,
  renderButtons,
  handleChange,
  clearError,
  timer,
  isLoading,
}) => {
  const { t: translate } = useTranslation();
  const history = useHistory();

  return (
    <OnboardingBodyLayout
      title={translate('email_verification_title')}
      renderButtons={renderButtons}
      withBack
      onPrevClick={history.goBack}>
      <p className="text-f5 text-dark mt-4">{translate('email_verification_subtitle')}</p>
      <form onSubmit={handleSubmit} id="email-confirmation">
        <Input
          subLabel={`${translate('email_verification_message_label')} ${timer} ${translate(
            'email_verification_subtext_label_sec'
          )}`}
          value={form.code}
          groupClassName={`mb-0 mt-4 mt-md-5 ${isIOS ? 'ios' : ''}`}
          name="code"
          type="number"
          className={`${isIOS ? 'ios' : ''}`}
          onChange={handleChange}
          onFocus={clearError}
          actionLabel={translate('resend_button_label')}
          actionClick={handleSendEmail}
          actionDisabled={timer > 0 || isLoading}
          placeholder={translate('email_verification_input_label')}
          label={translate('email_verification_input_label')}
          errorLabel={translate('verification_code_error_label')}
          autoComplete="off"
          actionBtnTop="18%"
          withFloatingLabel
          withSubLabel
          withErrorLabel
        />
      </form>
    </OnboardingBodyLayout>
  );
};

ConfirmEmailComponent.propTypes = {
  form: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleSendEmail: PropTypes.func.isRequired,
  renderButtons: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  timer: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
};
